
/**
 * State for the notification component
 *
 * @export
 * @class State
 */
export class State {
	title: string;
	mensage: string;
}

export const initialState: State = {
	title: '',
	mensage: '',
};
